import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';
import moment from 'moment';

export interface CreatedBy {
    displayName: string;
    email: string;
    firstName: string;
    fullName: string;
    id: string;
    isClaimant: boolean;
    isPolicyHolder: boolean;
    isSystem: boolean;
    lastName: string;
}

export interface DocumentType {
    id: string;
    code: string;
    name: string;
}

export interface ClaimDocument {
    id: string;
    createdById: string;
    createdBy: CreatedBy;
    documentTypes: Array<DocumentType>;
    createdDate: string;
    fullFileName: string;
    fileName: string;
    fileExtension: string;
    fileContent: string;
    questionId: string;
    questionName: string;
    messageId: string;
    messageContent: string;
    documentType: Array<string> | null;
}
export interface GeneralResponse {
    data: ClaimDocument;
    page: number;
    limit: number;
    totalPages: number;
    count: number;
    totalCount: number;
}
export const fetchClaimDocument = createAction<fetchClaimDocumentAction>(
    ActionTypes.FETCH_CLAIM_DOCUMENT,
);
export const fetchClaimDocumentSuccess =
    createAction<fetchClaimDocumentSuccessAction>(
        ActionTypes.FETCH_CLAIM_DOCUMENT_SUCCESS,
    );
export const fetchClaimDocumentFailed =
    createAction<fetchClaimDocumentFailedAction>(
        ActionTypes.FETCH_CLAIM_DOCUMENT_FAILED,
    );
export const fetchClaimDocumentWithQueryParams =
    createAction<fetchClaimDocumentWithQueryParamsAction>(
        ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS,
    );
export const fetchClaimDocumentWithQueryParamsSuccess =
    createAction<fetchClaimDocumentWithQueryParamsSuccessAction>(
        ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_SUCCESS,
    );
export const fetchClaimDocumentWithQueryParamsFailed =
    createAction<fetchClaimDocumentWithQueryParamsFailedAction>(
        ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_FAILED,
    );

export interface fetchClaimDocumentAction {
    type: typeof ActionTypes.FETCH_CLAIM_DOCUMENT;
}

export interface fetchClaimDocumentSuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_DOCUMENT_SUCCESS;
    body: GeneralResponse;
}

export interface fetchClaimDocumentFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_DOCUMENT_FAILED;
}

export interface fetchClaimDocumentWithQueryParamsAction {
    type?: typeof ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS;
    claimApplicationId: string;
    filters: {
        page: number;
        limit: number;
        submittedByAragUserOnly?: moment.MomentInput | null;
        submissionDateStart?: moment.MomentInput | null;
        submissionDateEnd?: string | null;
        attachmentFullFileNameLike?: string | null;
    };
}
export interface fetchClaimDocumentWithQueryParamsSuccessAction {
    type: typeof ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_SUCCESS;
    body: GeneralResponse;
}
export interface fetchClaimDocumentWithQueryParamsFailedAction {
    type: typeof ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_FAILED;
    payload: any;
}
